import React, { useState } from 'react';

const cancelReasons = [
  'Driver is taking too long',
  'I made a mistake in the order',
  'Found another option',
  'Emergency situation',
  'Other',
];

const OrderActions = ({ onShareTracking, onCancelOrder }) => {
  const [showCancelDialog, setShowCancelDialog] = useState(false);
  const [selectedReason, setSelectedReason] = useState('');
  const [showShareToast, setShowShareToast] = useState(false);

  const handleShare = () => {
    const trackingUrl = `${window.location?.origin}/track/OTG-${Math.random()?.toString(36)?.substr(2, 8)?.toUpperCase()}`;
    if (navigator.clipboard) {
      navigator.clipboard?.writeText(trackingUrl)?.then(() => {
        setShowShareToast(true);
        setTimeout(() => setShowShareToast(false), 3000);
      });
    } else {
      setShowShareToast(true);
      setTimeout(() => setShowShareToast(false), 3000);
    }
    onShareTracking?.();
  };

  const handleCancelConfirm = () => {
    if (selectedReason) {
      onCancelOrder?.(selectedReason);
      setShowCancelDialog(false);
    }
  };

  return (
    <>
      <div className="bg-white rounded-2xl p-4 border border-[#0a1628]/8">
        <h3 className="text-xs font-bold text-[#0a1628]/40 uppercase tracking-wider mb-3">Order Actions</h3>
        <div className="space-y-2">
          {/* Share tracking */}
          <button
            onClick={handleShare}
            className="w-full flex items-center gap-3 p-3 rounded-xl hover:bg-[#0a1628]/4 transition-colors group"
          >
            <div className="w-9 h-9 rounded-xl bg-[#ffd700]/15 flex items-center justify-center group-hover:bg-[#ffd700]/25 transition-colors">
              <svg viewBox="0 0 24 24" fill="#0a1628" className="w-4 h-4">
                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92s2.92-1.31 2.92-2.92-1.31-2.92-2.92-2.92z" />
              </svg>
            </div>
            <div className="flex-1 text-left">
              <p className="text-sm font-semibold text-[#0a1628]">Share Tracking Link</p>
              <p className="text-xs text-[#0a1628]/40">Send live location to recipient</p>
            </div>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 text-[#0a1628]/30">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>

          {/* Cancel order */}
          <button
            onClick={() => setShowCancelDialog(true)}
            className="w-full flex items-center gap-3 p-3 rounded-xl hover:bg-red-50 transition-colors group"
          >
            <div className="w-9 h-9 rounded-xl bg-red-50 flex items-center justify-center group-hover:bg-red-100 transition-colors">
              <svg viewBox="0 0 24 24" fill="#ef4444" className="w-4 h-4">
                <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
              </svg>
            </div>
            <div className="flex-1 text-left">
              <p className="text-sm font-semibold text-red-600">Cancel Order</p>
              <p className="text-xs text-[#0a1628]/40">Cancellation fee may apply</p>
            </div>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="w-4 h-4 text-[#0a1628]/30">
              <path d="M9 18l6-6-6-6" />
            </svg>
          </button>
        </div>
      </div>
      {/* Share toast */}
      {showShareToast && (
        <div className="fixed top-20 left-1/2 -translate-x-1/2 z-50 bg-[#0a1628] text-white text-sm font-medium px-4 py-2.5 rounded-xl shadow-xl flex items-center gap-2 animate-fade-in">
          <svg viewBox="0 0 24 24" fill="#ffd700" className="w-4 h-4">
            <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
          </svg>
          Tracking link copied!
        </div>
      )}
      {/* Cancel dialog */}
      {showCancelDialog && (
        <div className="fixed inset-0 z-50 flex items-end justify-center bg-black/50 backdrop-blur-sm p-4">
          <div className="w-full max-w-md bg-white rounded-3xl p-6 shadow-2xl">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-xl bg-red-100 flex items-center justify-center">
                <svg viewBox="0 0 24 24" fill="#ef4444" className="w-5 h-5">
                  <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
                </svg>
              </div>
              <div>
                <h3 className="font-bold text-[#0a1628] text-base">Cancel Order?</h3>
                <p className="text-xs text-[#0a1628]/50">A cancellation fee of KSh 50 may apply</p>
              </div>
            </div>

            <p className="text-sm text-[#0a1628]/60 mb-3">Please select a reason:</p>
            <div className="space-y-2 mb-5">
              {cancelReasons?.map(reason => (
                <button
                  key={reason}
                  onClick={() => setSelectedReason(reason)}
                  className={`w-full text-left px-4 py-3 rounded-xl text-sm font-medium transition-all ${
                    selectedReason === reason
                      ? 'bg-[#0a1628] text-white'
                      : 'bg-[#0a1628]/5 text-[#0a1628] hover:bg-[#0a1628]/10'
                  }`}
                >
                  {reason}
                </button>
              ))}
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => { setShowCancelDialog(false); setSelectedReason(''); }}
                className="flex-1 py-3 rounded-xl border border-[#0a1628]/15 text-[#0a1628] font-semibold text-sm hover:bg-[#0a1628]/5 transition-colors"
              >
                Keep Order
              </button>
              <button
                onClick={handleCancelConfirm}
                disabled={!selectedReason}
                className={`flex-1 py-3 rounded-xl font-semibold text-sm transition-all ${
                  selectedReason
                    ? 'bg-red-500 text-white hover:bg-red-600 active:scale-95' :'bg-red-100 text-red-300 cursor-not-allowed'
                }`}
              >
                Cancel Order
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OrderActions;
